import React, { FC } from "react";
import { ConfigProvider, Form, InputNumber, Select, Table } from "antd";
import { FinanceRow } from "../../../../../../store/slice/applicationDataToBankSlice/applicationDataToBankSlice";
import { ruleRequired } from "../../../../../../constants/rules/RulesConstantsForms";
import { financeTableParser, yearSelectOptions } from "./utils";
import { useParams } from "react-router-dom";
import { useGetApplicationDataToBankQuery } from "../../../../../../store/api/applicationBankApi/applicationBank.api";
import { APPLICATION_BANK_STATUS_KKB } from "../../../../../../utils/guards/ApplicationBankStatusGuard/types";

import classes from "./FinanceTable.module.css";
interface IFinanceTable {
  dataSource: FinanceRow[];
  codes: string[];
}

export const FinanceTable: FC<IFinanceTable> = (props) => {
  const statuses = [
    APPLICATION_BANK_STATUS_KKB.PROCESSING,
    APPLICATION_BANK_STATUS_KKB.REVISION,
  ];
  const { dataSource, codes } = props;

  const { applicationId, applicationBankId } = useParams();

  const { data: applicationBankData } = useGetApplicationDataToBankQuery({
    applicationId: Number(applicationId),
    applicationBankId: Number(applicationBankId),
  });

  // Вид формы - редактирование или нет
  const isOnEditForm = statuses.some(
    (status) => status === applicationBankData?.status.type,
  );
  const columns = [
    {
      title: "Наименование показателя",
      dataIndex: "title",
      width: "50%",
      onCell: (record: any) => ({
        colSpan: !record.code ? 4 : 1,
      }),
      render: (value: string, row: FinanceRow, index: number) => {
        if (!row.code) {
          return <span className={classes.financeTableTitleRow}>{value}</span>;
        }

        return <span>{value}</span>;
      },
    },
    {
      title: "Код",
      dataIndex: "code",
      width: "10%",
      onCell: (record: any) => ({
        colSpan: !record.code ? 0 : 1,
      }),
    },
    {
      title: (
        <Form.Item
          style={{ margin: 0, width: "100%", padding: 0 }}
          name={["accountingBalance", "balance_date_rc"]}
        >
          <Select disabled={!isOnEditForm} options={yearSelectOptions} />
        </Form.Item>
      ),
      dataIndex: "lc",
      width: "10%",
      render: (value: string, row: FinanceRow, index: number) => {
        if (!row.code) {
          return null;
        }
        return (
          <Form.Item
            style={{ margin: 0, width: "100%", padding: 0 }}
            name={["accountingBalance", "data", codes[index], "lc"]}
            initialValue={value}
            rules={row.code === "2110" ? [ruleRequired] : undefined}
          >
            {isOnEditForm ? (
              <InputNumber
                parser={financeTableParser}
                style={{ width: "100%" }}
                controls={false}
              />
            ) : (
              <span>{value}</span>
            )}
          </Form.Item>
        );
      },
      onCell: (record: any) => ({
        colSpan: !record.code ? 0 : 1,
      }),
    },
    {
      title: (
        <Form.Item
          style={{ margin: 0, width: "100%", padding: 0 }}
          name={["accountingBalance", "balance_date_lc"]}
        >
          Квартал
        </Form.Item>
      ),
      dataIndex: "rc",
      width: "10%",
      render: (value: string, row: FinanceRow, index: number) => {
        if (!row.code) {
          return null;
        }

        return (
          <Form.Item
            style={{ margin: 0, width: "100%", padding: 0 }}
            name={["accountingBalance", "data", codes[index], "rc"]}
            initialValue={value}
          >
            <InputNumber
              parser={financeTableParser}
              style={{ width: "100%" }}
              controls={false}
            />
          </Form.Item>
        );
      },
      onCell: (record: any) => ({
        colSpan: !record.code ? 0 : 1,
      }),
    },
  ];

  return (
    <ConfigProvider
      theme={{
        components: {
          Table: {
            borderRadius: 12,
            rowHoverBg: "#eaeaea",
            headerBg: "#F3F3F3",
            borderColor: "#0000002E",
          },
        },
      }}
    >
      <Table
        columns={columns}
        dataSource={dataSource}
        bordered
        pagination={false}
        className={classes.financeTable}
      />
    </ConfigProvider>
  );
};
